import { render, staticRenderFns } from "./EtagBanner.vue?vue&type=template&id=0fff2d82&scoped=true"
import script from "./EtagBanner.vue?vue&type=script&lang=js"
export * from "./EtagBanner.vue?vue&type=script&lang=js"
import style0 from "./EtagBanner.vue?vue&type=style&index=0&id=0fff2d82&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff2d82",
  null
  
)

export default component.exports